import { Phone, MapPin, Clock, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Reveal } from "./Reveal";

export const Footer = () => (
  <footer id="contact" data-testid="footer" className="border-t border-white/10 bg-[#050505]">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal className="py-20 text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#D4AF37]">Un impact sur votre pare-brise ?</p>
        <h2 className="mx-auto mt-4 max-w-3xl font-display text-4xl uppercase leading-tight text-white sm:text-5xl lg:text-6xl">
          N'attendez pas que la fissure <span className="text-gold-gradient">s'étende</span>
        </h2>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            href="tel:0602259560"
            data-testid="footer-phone-cta"
            className="inline-flex items-center gap-3 rounded-full bg-[#D4AF37] px-8 py-4 text-sm font-bold uppercase tracking-widest text-black transition-colors hover:bg-[#F3E5AB]"
          >
            <Phone className="h-5 w-5" /> 06 02 25 95 60
          </a>
          <a
            href="#rendez-vous"
            data-testid="footer-booking-cta"
            className="inline-flex items-center gap-3 rounded-full border border-white/20 px-8 py-4 text-sm font-bold uppercase tracking-widest text-white transition-colors hover:border-[#D4AF37] hover:text-[#E6CA65]"
          >
            Prendre rendez-vous en ligne
          </a>
        </div>
      </Reveal>

      <div className="grid gap-10 border-t border-white/10 py-14 md:grid-cols-3">
        <div>
          <Logo />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-zinc-500">
            Spécialiste du remplacement de pare-brise à domicile ou sur place. Bordeaux &amp; ses alentours.
          </p>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-zinc-500">Coordonnées</p>
          <ul className="mt-5 space-y-3 text-sm text-zinc-300">
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#D4AF37]" />
              12 Chemin Tillon, 33140 Villenave d'Ornon
            </li>
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 shrink-0 text-[#D4AF37]" />
              <a href="tel:0602259560" data-testid="footer-phone-link" className="transition-colors hover:text-[#E6CA65]">
                06 02 25 95 60
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MessageCircle className="h-4 w-4 shrink-0 text-[#D4AF37]" />
              Snapchat : MOTOR-SELECT
            </li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-zinc-500">Horaires</p>
          <ul className="mt-5 space-y-3 text-sm text-zinc-300">
            <li className="flex items-center gap-3">
              <Clock className="h-4 w-4 shrink-0 text-[#D4AF37]" />
              Lundi – Samedi : 13h00 – 20h00
            </li>
            <li className="flex items-center gap-3">
              <Clock className="h-4 w-4 shrink-0 text-[#D4AF37]" />
              Urgences : appelez-nous directement
            </li>
          </ul>
        </div>
      </div>

      <div className="flex flex-col items-center justify-between gap-4 border-t border-white/10 py-6 text-xs text-zinc-600 sm:flex-row">
        <p>© 2026 Motor Select — Tous droits réservés. *Voir conditions sur demande.</p>
        <Link to="/admin/login" data-testid="footer-admin-link" className="transition-colors hover:text-[#E6CA65]">
          Espace pro
        </Link>
      </div>
    </div>
  </footer>
);
